import { AnimateWordsOnScroll } from "../../../components/animate/animateWords";
import { FloatY } from "../../../components/animate/floatY";
import { ScribbleReveal } from "../../../components/animate/scribbleReveal";
import { TestimonialCarousel } from "../../../components/carousel/testimonialCarousel";
import { scribblePaths, testimonialSlides } from "../data/landingContent";

export const TestimonialSection = () => {
  return (
    <section className="max-width-website relative py-12 md:py-16">
      <AnimateWordsOnScroll
        as="h2"
        className="relative mx-auto mb-10 block w-fit text-center font-dela text-[28px] leading-[1.15] text-ink md:mb-14 md:text-[44px]"
      >
        Trusted by{" "}
        <span className="relative inline-block">
          growing
          <ScribbleReveal
            {...scribblePaths.testimonial}
            className="pointer-events-none absolute bottom-[-14%] left-[-3.3%] right-[-3.3%] top-[-14%] -z-10"
          />
        </span>{" "}
        creators
      </AnimateWordsOnScroll>

      <div className="relative">
        <TestimonialCarousel slides={testimonialSlides} />
        <FloatY
          direction="up"
          duration={8.5}
          className="pointer-events-none absolute -bottom-4 -right-6 md:-bottom-10 md:-right-10"
        >
          <img
            src="/assets/images/landing-testimonial-user-glass.png"
            alt=""
            aria-hidden
            className="w-24 rotate-[13.5deg] sm:w-32 md:w-48 lg:w-56"
          />
        </FloatY>
      </div>
    </section>
  );
};
